module.exports = __webpack_public_path__ + "img/-s-icon02.9f6699e7.png";